import AbstractMediator from "../../../core/ui/AbstractMediator";
import EpilogueEvent from "../event/EpilogueEvent";
import DashboardData from "../../dashboard/model/DashboardData";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DashboardCumulativeDataFactory from "../../dashboard/controller/DashboardCumulativeDataFactory";
import DashboardNumberChartFactory from "../../dashboard/controller/DashboardNumberChartFactory";
import DashboardScreenMediator from "../../dashboard/view/DashboardScreenMediator";

export default class EpilogueScreenMediator extends DashboardScreenMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target
     * @param {soma.EventDispatcher} dispatcher
     * @param {LayoutManager} layoutManager
     * @param {ClickEaterFactory} clickEaterFactory
     * @param {RevisableLanguagePack} languagePack
     * @param {DashboardData} dashboardData
     * @param {DashboardCumulativeDataFactory} dashboardCumulativeDataFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardData, variableManager, mediatorManager, dashboardCumulativeDataFactory, saveGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager, saveGameModel);

        this._variableManager = variableManager;
        this._dashboardData = dashboardData;
        this._dashboardCumulativeDataFactory = dashboardCumulativeDataFactory;
        this._phase = 0;
        this.cumulativeData = [];

    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        this._target.DashboardTab1.Annotation1.alpha = 1;
        this._target.DashboardTab1.Annotation2.alpha = 1;
        this._target.DashboardTab2.Annotation3.alpha = 1;
        this._target.DashboardTab2.GlobeEpilogue.alpha = 1;
        this._target.DashboardTab2.GlobeTab2.alpha = 0;

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab1.Annotation1,
            "dashboard.cumulativeData.numberCumulativeCases",
            DashboardData.NODE_CUMULATIVE_CASES
        ));

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab1.Annotation2,
            "dashboard.cumulativeData.numberCumulativeDeaths",
            DashboardData.NODE_CUMULATIVE_DEATHS
        ));

        this.cumulativeData.push(this._dashboardCumulativeDataFactory.createCumulativeData(this._target.DashboardTab2.Annotation3,
            "dashboard.cumulativeData.numberNonEnvd",
            DashboardData.NODE_CUMULATIVE_NON_ENVD
        ));

        this.forceEpiTab();
        this.hideCumulativeData();
        this._continueButton = this.createButton(this._target.EpilogueContinueButton, this._handleContinueButton.bind(this), this._languagePack.getText('epilogue.continueButton'));
        this._localiseTexts();
    }

    
    _localiseTexts() {
        this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step1');
        this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step1');
        this._target.DashboardTab1.LabelTab1.alpha = 0;
        this._target.DashboardTab2.LabelTab2.alpha = 0;
        this._target.DashboardTab1.LabelTab1Color.alpha = 1;
        this._target.DashboardTab2.LabelTab2Color.alpha = 1;
        this._target.DashboardTab1.LabelTab1Color.text = this._languagePack.getText(`epilogue.legend`);
        this._target.DashboardTab2.LabelTab2Color.text = this._languagePack.getText(`epilogue.legend`);
    }

    forceEpiTab() {
        this._handleTabEpiButton();
    }

    forceHealthSystemsTab() {
        this._handleTabHealthSystemsButton();
    }

    hideCumulativeData() {
        this.cumulativeData.forEach((cumulativeDataMediator) => {
            cumulativeDataMediator.hide();
        });
    }

    showCumulativeData() {
        this.cumulativeData.forEach((cumulativeDataMediator) => {
            cumulativeDataMediator.show();
        });
    }


    destroy() {
        super.destroy();
    }

    _handleContinueButton() {
        ++this._phase;
        switch (this._phase) {
            case 1:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step2');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step2');
                this.showCumulativeData();
                break;
            case 2:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step3');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step3');
                this.forceHealthSystemsTab();
                this.hideCumulativeData();
                break;
            case 3:
                this._target.TitleSubTextField.text = this._languagePack.getText('epilogue.subtitles.step4');
                this._target.subTitleTextField.text = this._languagePack.getText('epilogue.tabTitle.step4');
                this.showCumulativeData();
                break;
            default:
                this.dispatch(EpilogueEvent.CLOSE_REQUEST);
        }
    }
}